import { RedocStandalone } from 'redoc';
import { useLocation } from 'react-router-dom';

const ApiDocs = () => {
  const {pathname} = useLocation();
  const specUrl = pathname === "/robotaxiV1" ? "openapi-v1.1.0.yaml" : "/openapi.yaml";
  return (
    <div style={{ marginTop: '20px' }}>
      <RedocStandalone
        specUrl={specUrl} // Points to the file in the public folder
        options={{
          nativeScrollbars: true,
          theme: { colors: { primary: { main: '#dd5522' } } },
        }}
      />
    </div>
  );
};

export default ApiDocs;
